import axios from '@/utils/request'
import base from '@/api/base'

/**
 * 客服-客户资料聚合查询（会话内嵌，controller/agent /v1/agent/customer-profile）
 * 返回 { customer, kyc, deposits, withdraws, customerId }，单项失败置空/错误字段，不整体失败。
 */
export function getCustomerProfile(customerId) {
  return axios.get(`${base.url}/service/v1/agent/customer-profile`, { params: { customerId } })
}